import "../components/styles.css";
import React from "react";
import CalendarPicker from "../components/calendar-picker";
import VacationItem from "../components/vacation-item";
import Toggle from "../components/switch";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import Time from "../components/time";

export default function DaysHalfAndHoursDisabled({
  checked,
  onChecked,
  defaultAM,
  onHandleToggle,
  is24HoursFormat,
  timeFrom,
  onSelectTimeFrom,
  isShowHours,
  onShowHoursChecked,
  dateTo,
  dateFrom,
  timeTo,
  onSelectTimeTo,
  isMobile,
}) {
  return (
    <>
      <div
        className="check-in-out-container"
        id="days-half-and-hours-disabled-from-container"
      >
        <CalendarPicker
          label={"From"}
          isStanAlone
          isDisabled
          value={dateFrom}
          id="days-half-and-hours-disabled-calendar-from-component"
        />
        {isShowHours && (
          <Time
            label={"Time"}
            ampm={!is24HoursFormat}
            value={timeFrom}
            onChange={(value) => onSelectTimeFrom?.(value)}
            id="days-half-and-hours-disabled-time-from-component"
          />
        )}
        {checked && (
          <Toggle
            defaultAM={defaultAM}
            onHandleToggle={onHandleToggle}
            value={dateTo}
            id="days-half-and-hours-disabled-toggle-half-day-component"
          />
        )}
      </div>
      <div
        className="check-in-out-container"
        id="days-half-and-hours-disabled-to-container"
      >
        <CalendarPicker
          label={"To"}
          isDisabled
          isStanAlone
          id="days-half-and-hours-disabled-calendar-to-component"
        />
        {isShowHours && (
          <Time
            label={"Time"}
            ampm={!is24HoursFormat}
            value={timeTo}
            onChange={(value) => onSelectTimeTo?.(value)}
            id="days-half-and-hours-disabled-time-to-component"
          />
        )}
        {checked && (
          <div
            className="empty"
            id="empty-view"
            style={{
              marginLeft: 20,
              marginRight: 20,
              width: isMobile ? 205 : 155,
            }}
          ></div>
        )}
      </div>
      <div
        className="time"
        id="days-half-and-hours-disabled-show-hours-container"
      >
        <VacationItem
          checked={isShowHours}
          onChecked={onShowHoursChecked}
          title={"Show hours"}
          icon={AccessTimeIcon}
          color={"#35a3dc"}
          id="days-half-and-hours-disabled-show-hours-component"
        />
      </div>
      <div
        className="toggle"
        id="days-half-and-hours-disabled-half-day-container"
      >
        <VacationItem
          checked={checked}
          onChecked={onChecked}
          title={"Half day"}
          icon={HourglassBottomIcon}
          color={"orange"}
          id="days-half-and-hours-disabled-half-day-component"
        />
      </div>
    </>
  );
}
